import { z } from 'zod';

export const NOTIFICATION_AUDIENCE_SELECTOR_TYPES = Object.freeze([
    'user',
    'role',
    'unit',
    'title',
    'assignmentTemplate',
    'eventRelation',
    'pageViewers',
]);

const objectIdSchema = z.string().regex(/^[0-9a-fA-F]{24}$/, 'Expected a MongoDB ObjectId');
const idsSchema = z.array(objectIdSchema).min(1).max(100);

export const NotificationAudienceSelectorSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('user'), ids: idsSchema }).strict(),
    z.object({ type: z.literal('role'), ids: idsSchema }).strict(),
    z.object({ type: z.literal('unit'), ids: idsSchema }).strict(),
    z.object({ type: z.literal('title'), values: z.array(z.string().min(1).max(120)).min(1).max(50) }).strict(),
    z.object({ type: z.literal('assignmentTemplate'), id: objectIdSchema }).strict(),
    z.object({
        type: z.literal('eventRelation'),
        relation: z.string().min(1).max(64).regex(/^[a-z][A-Za-z0-9]*$/),
    }).strict(),
    z.object({ type: z.literal('pageViewers') }).strict(),
]);

export const NotificationAudienceExpressionSchema = z.object({
    include: z.array(NotificationAudienceSelectorSchema).min(1).max(20),
    exclude: z.array(NotificationAudienceSelectorSchema).max(20).default([]),
}).strict();
